import { reactive } from 'vue'

interface Result {
  risk: number | null,
  hba1c: string
}

type State = {
  barcode: string
  result: Result | null
  pinCode: number | null
}

export const initialState: State = {
  barcode: '',
  result: null,
  pinCode: null,
}

export const state = reactive<State>({ ...initialState })
